import React from 'react';
import moment from "moment";
import { Page, PageHeader, PageBody } from "../base/Page";
import { browserHistory } from "react-router";
import Auth from "../auth/Auth";
import { Button, Row, Col, Panel, FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import API from "../base/API";
import { translate } from "../base/Translation";

let DatePicker = require("react-bootstrap-date-picker");

export default class TestEdit extends Auth {

	constructor(props) {
		super(props);

		this.api = new API({
			get_test: "/test/fetch/:test",
			save_test: "/test/save/:test",
			get_users: "/user/fetch/by/role/:role",
			get_weaves: "/weave/fetch/all",
			get_vehicles: "/vehicle/fetch/all",
			get_branches: "/branch/fetch/all",
			get_branches_by_weave: "/branch/fetch/by/weave/:weave",
		});

		this.state = {
			test: null,
			users: [],
			externals: [],
			branches: [],
			vehicles: [],
			weaves: [],
			branchBrand: 0,
		};
	}

	async fetchData() {

		this.api.request({
			route: "get_test",
			params: { "test": this.props.params.testID },
			success: (response) => {
				this.setState({ test: response, branchBrand: response.branch ? response.branch_data.brand_id : 0 });
				this.reloadBranches();
			}
		});

		this.api.request({
			route: "get_users",
			params: { role: "5" },
			success: (response) => {
				this.setState({ users: response });
			}
		});

		this.api.request({
			route: "get_users",
			params: { role: 4 },
			success: (response) => {
				this.setState({ externals: response });
			}
		});


		this.api.request({
			route: "get_weaves",
			success: (response) => {
				this.setState({ weaves: response });
			}
		});

		this.api.request({
			route: "get_vehicles",
			success: (response) => {
				this.setState({ vehicles: response });
			}
		});

		
	}



	reloadBranches(resetBranch = false) {

		let funcAfter = (testBranches) => {
			let newTest = this.state.test;
			if (resetBranch) {
				newTest.branch = 0;
			}

			testBranches = testBranches.map((item) => {
				item.name = (item.city ? item.city + ", " : "") + (item.identifier ? item.identifier + ", " : "") + item.name + (item.address ? ", " + item.address : "");
				return item;
			});

			testBranches.sort(function (a, b) {
				if (a.name < b.name) return -1;
				if (a.name > b.name) return 1;
				return 0;
			})

			this.setState({
				branches: testBranches,
				test: newTest
			});
		};

		if (this.state.test && this.state.test.weave !== 0) {
			this.api.request({
				route: "get_branches_by_weave",
				params: { weave: this.state.test.weave },
				success: (response) => {
					funcAfter(response);
				}
			});
		} else {
			this.api.request({
				route: "get_branches",
				success: (response) => {
					funcAfter(response);
				}
			});
		}
	}

	onTestSave(evt) {
		this.api.request({
			route: "save_test",
			params: { test: this.props.params.testID },
			data: this.state.test,
			created: (response) => {
				browserHistory.push("/tests");
			}
		});
	}

	componentDidMount() {
		this.fetchData();
	}

	onTestChange(evt) {
		// Get test from state
		let newTest = this.state.test;

		// Update it's value
		newTest[evt.target.name] = evt.target.value;

		// Update test in state
		this.setState({ test: newTest });

		if (evt.target.name === "weave") {
			this.reloadBranches(true);
		}

		if (evt.target.name === "branch") {
			let branch = this.state.branches.filter((branch) => { return parseInt(branch.id, 10) === parseInt(evt.target.value, 10) });
			this.setState({ branchBrand: branch[0].brand.id });
		}

	}

	onTestDateChange(evt, date) {
		// Get test from state
		let newTest = this.state.test;

		// Update it's value
		newTest.date = date;

		// Update test in state
		this.setState({ test: newTest });
	}

	renderWeaveSelect() {
		return this.state.weaves.map(function (weave) {
			return (
				<option value={weave.id} key={weave.id}>{weave.name}</option>
			)
		});
	}

	renderBranchSelect() {
		return this.state.branches.map(function (branch) {
			return (
				<option value={branch.id} key={branch.id}>{branch.name}</option>
			)
		});
	}

	renderUserSelect(userType = false) {
		if (userType === "external") {
			return this.state.externals.map(function (user) {
				return (
					<option value={user.id} key={user.id}>{user.name} {user.surname}</option>
				)
			});
		} else if (userType === "include_admin") {
			return this.state.users.map(function (user) {
				return (
					<option value={user.id} key={user.id}>{user.name} {user.surname}</option>
				)
			});
		} else {
			return this.state.users.map(function (user) {
				if (parseInt(user.role_id, 10) !== 5) {
					return false;
				}
				return (
					<option value={user.id} key={user.id}>{user.name} {user.surname}</option>
				)
			});
		}
	}

	renderVehicleSelect() {
		return this.state.vehicles.map((vehicle) => {
			if (vehicle.brand !== this.state.branchBrand) {
				return false;
			}
			return (
				<option value={vehicle.id} key={vehicle.id}>{vehicle.ecv}</option>
			)
		});
	}

	render() {

		if (this.state.test === null) {
			return (
				<Page>
					<PageHeader>{translate("Prosím počkajte")}</PageHeader>
					<PageBody>{translate("Obsah sa načítava")}</PageBody>
				</Page>
			);
		}

		let date = moment(this.state.test.date, 'DD.MM.YYYY').format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");

		return (
			<Page>
				<PageHeader title={this.state.test.name} />
				<PageBody>
					<Row>
						<Col lg={6}>
							<Panel header={translate("Základné")}>
								<FormGroup>
									<ControlLabel>{translate("Názov")}</ControlLabel>
									<FormControl disabled value={this.state.test.name} name="name"
										onChange={this.onTestChange.bind(this)} />
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("Dátum")}</ControlLabel>
									<DatePicker value={date} dateFormat="DD.MM.YYYY"
										onChange={this.onTestDateChange.bind(this)} />
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("Vlna")}</ControlLabel>
									<FormControl componentClass="select" name="weave" value={this.state.test.weave}
										onChange={this.onTestChange.bind(this)}>
										<option value={0}>{translate("Vyberte")}</option>
										{this.renderWeaveSelect()}
									</FormControl>
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("Prevádzka")}</ControlLabel>
									<FormControl componentClass="select" name="branch" value={this.state.test.branch}
										onChange={this.onTestChange.bind(this)}>
										<option value={0}>{translate("Vyberte")}</option>
										{this.renderBranchSelect()}
									</FormControl>
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("Vozidlo")}</ControlLabel>
									<FormControl componentClass="select" name="vehicle" value={this.state.test.vehicle}
										onChange={this.onTestChange.bind(this)}>
										<option value={0}>{translate("Vyberete")}</option>
										{this.renderVehicleSelect()}
									</FormControl>
								</FormGroup>
							</Panel>
						</Col>
						<Col lg={6}>
							<Panel header={translate("Používatelia")}>
								<FormGroup>
									<ControlLabel>{translate("Supervízor")}</ControlLabel>
									<FormControl componentClass="select" name="supervisor"
										value={this.state.test.supervisor} onChange={this.onTestChange.bind(this)}
										placeholder="select">
										<option value={0}>{translate("Vyberte")}</option>
										{this.renderUserSelect("include_admin")}
									</FormControl>
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("Inšpektor")}</ControlLabel>
									<FormControl componentClass="select" name="internal_user"
										value={this.state.test.internal_user}
										onChange={this.onTestChange.bind(this)} placeholder="select">
										<option value={0}>{translate("Vyberte")}</option>
										{this.renderUserSelect("include_admin")}
									</FormControl>
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("Externý používateľ")}</ControlLabel>
									<FormControl componentClass="select" name="external_user"
										value={this.state.test.external_user}
										onChange={this.onTestChange.bind(this)} placeholder="select">
										<option value={0}>{translate("Vyberte")}</option>
										{this.renderUserSelect("external")}
									</FormControl>
								</FormGroup>
							</Panel>
						</Col>
					</Row>
					<Row>
						<Col lg={12}>
							<FormGroup>
								<Button bsStyle="success" onClick={this.onTestSave.bind(this)}>{translate("Uložiť")}</Button>
							</FormGroup>
						</Col>
					</Row>
				</PageBody>
			</Page>
		);
	}
}


// WEBPACK FOOTER //
// ./src/modules/test/TestEdit.js